import {
  computed, onUnmounted, reactive, ref,
} from '@vue/composition-api'
import store from '@/store'

const DEFAULT_CONFIG = {
  key: 'Jordan::Amman::ride-hailing::economy',
  cancellation_reasons: [
    {
      localId: '0.8769889327376399',
      label:
        'Captain does not answer customer calls / number disconnected - closed',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '836eef47-4035-4f24-8d3f-f8bb12333e2a',
    },
    {
      localId: '0.6701704831394406',
      label: 'The Captain forget to cancel the trip from his side',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 'd7838994-b081-4e62-ad46-9793dfba4bb6',
    },
    {
      localId: '0.3862390752454101',
      label: 'The rider get in another vehicle , The captain left the location',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '2833330b-d01e-4fef-b6d2-eea113c384aa',
    },
    {
      localId: '0.31227250720464017',
      label: 'The number of Rider is more than 4',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '511b1794-bd20-443a-8be5-cbcb12b88f4b',
    },
    {
      localId: '0.3998941775568772',
      label: 'Technical issue',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 'b192b20e-d947-473d-9f19-316b9362286f',
    },
    {
      localId: '0.3735333244466288',
      label: 'Dead zone',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '1cfe64c1-aa09-4ecb-821c-c95b1c1940b6',
    },
    {
      localId: '0.8466999828680191',
      label: 'Different captain/Car',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '28cf3203-8659-46f4-a3fe-eac05ad471d9',
    },
    {
      localId: '0.709835350457835',
      label: 'Destination Refuse',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '328b1b37-bfd0-49c9-b763-9923c645b2db',
    },
    {
      localId: '0.4080299877608724',
      label: 'Car accident',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '36e96613-9b4b-4362-b58f-35237ee15fbc',
    },
    {
      localId: '0.882315958923984',
      label: 'Car Issue',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 'fae1d6cb-967a-433d-a48b-23c38d9c8f46',
    },
    {
      localId: '0.8778358048519252',
      label:
        'Wrong address from the customer ( The captain tried to reach the correct address )',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '9f1348fe-e4f0-40d4-be87-5d3ee8aec28b',
    },
    {
      localId: '0.797372685707735',
      label: 'Destination Refuse',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '1b1addfc-f988-4b08-9811-97e4d7666249',
    },
    {
      localId: '0.05896964091483703',
      label:
        'Captain does not answer customer calls / number disconnected - closed',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '54659264-66f1-4e83-b79b-9abd8fafb7f0',
    },
    {
      localId: '0.9326109987351192',
      label:
        'The rider location is within the university or a commercial complex',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 'd0358c02-753c-42e4-bd12-15a53be3fe68',
    },
    {
      localId: '0.7938086278410665',
      label: 'The captain has bad history with the customer',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 'fc622e68-476b-4c18-82c7-51ae4b75129f',
    },
    {
      localId: '0.6318328118992478',
      label: 'Suspended trip',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '90501a63-e1da-43ff-8b6b-3b85f59fc15c',
    },
    {
      localId: '0.23922456251451307',
      label: 'Technical issue ( The trip is not shown at the Captain App)',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 'f2aae5e9-e37a-46b3-86d6-f9fd37d95413',
    },
    {
      localId: '0.7894346706216275',
      label: 'The Customer stands next to the Police',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '77dd1d8d-d79f-4d61-864c-2ccae930896e',
    },
    {
      localId: '0.4395782502314558',
      label: 'An unpaved road',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '3e2d00dd-bb17-42fe-a3cf-9f0bbf0dda79',
    },
    {
      localId: '0.2704611905967409',
      label: 'Car accident',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '70c3112f-c39d-4646-9b72-f30427f6c122',
    },
    {
      localId: '0.5141903670326591',
      label: 'The vehicle needs to be charged (Electric cars)',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '3e3a213d-c25e-45fa-8180-dad08537ffc2',
    },
    {
      localId: '0.14820777004549823',
      label: 'Car Issue',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '4b4013e3-0052-4f67-95e8-d38a847a87fa',
    },
    {
      localId: '0.12025154870763832',
      label: 'Accepted by mistake',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 'c2775a54-1a95-4a7e-9e34-3419ce2c7703',
    },
    {
      localId: '0.14023867164071735',
      label: 'Road closed',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '9af2cbd4-d0c2-49ea-9872-0e6b0bdc79cd',
    },
    {
      localId: '0.9400981506116',
      label: 'Personal Reason',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: '4ea9f702-79b6-4333-a0be-a73b95877624',
    },
    {
      localId: '0.039825072492464475',
      label: 'More than 5KM / 3KM',
      state: 'ACCEPTED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 87,
    },
    {
      localId: '0.6415127773899676',
      label: 'Wrong address from the customer',
      state: 'ACCEPTED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 111,
    },
    {
      localId: '0.5249333763646269',
      label: 'Flat tire',
      state: 'ACCEPTED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 123,
    },
    {
      localId: '0.8939739215860414',
      label: 'Traffic',
      state: 'ACCEPTED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 58,
    },
    {
      localId: '0.03211082086272832',
      label: 'Others',
      state: 'ARRIVED',
      duration_value: '0',
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 'b9f41ca5-f86b-449d-a243-b7727e4e9e9e',
    },
    {
      localId: '0.8113545369424469',
      label: 'Others',
      state: 'ACCEPTED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: false,
      admin: true,
      active: true,
      id: 93,
    },
    {
      label: 'Captain is too far',
      label_ar: 'الكابتن بعيد جداً',
      id: 45,
      state: 'ACCEPTED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: true,
      active: true,
      localId: '0.9703462421393563',
    },
    {
      label: 'I found another ride',
      label_ar: 'وجدت وسيلة أخرى',
      id: 90,
      state: 'ACCEPTED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: true,
      active: true,
      localId: '0.163287772828566',
    },
    {
      label: 'Captain has a low rating',
      label_ar: 'تقييم الكابتن منخفض',
      id: 50,
      state: 'ACCEPTED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: true,
      active: true,
      localId: '0.2905563841416783',
    },
    {
      label: 'Captain couldn’t locate me',
      label_ar: 'الكابتن لم يتمكن من إيجاد الموقع',
      id: 90,
      state: 'ACCEPTED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: true,
      active: true,
      localId: '0.6587310782896718',
    },
    {
      label: 'Captain isn’t responding',
      label_ar: 'الكابتن لا يستجيب للمكالمات',
      id: 47,
      state: 'ARRIVED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: true,
      active: true,
      localId: '0.6995464944456364',
    },
    {
      label: 'Car wasn’t suitable',
      label_ar: 'المركبة غير مناسبة',
      id: 48,
      state: 'ARRIVED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: true,
      active: true,
      localId: '0.5348578185578381',
    },
    {
      label: 'Captain couldn’t locate me',
      label_ar: 'الكابتن لم يتمكن من إيجاد الموقع',
      id: 49,
      state: 'ARRIVED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: true,
      active: true,
      localId: '0.7761690637765393',
    },
    {
      label: 'Arrived with different Captain or Car',
      label_ar: 'الكابتن مختلف أو السيارة مختلفة',
      id: 50,
      state: 'ARRIVED',
      duration_value: 0,
      operator: 'GREATER_THAN',
      driver: false,
      user: true,
      active: true,
      localId: '0.6622177816553783',
    },
  ],
  display_phone_options: {
    from_time: '6',
    to_time: '12',
    active: false,
  },
  driver_offer: {
    drop_coordinates: true,
    drop_address: true,
    distance_to_dropoff: false,
    distance_to_client: true,
    time_to_dropoff: false,
    time_to_client: true,
    cost_estimate: false,
    directions_to_dropoff: true,
    client_name: false,
    client_rating: false,
    show_payment: false,
  },
  fines: [
    {
      from: 'ACCEPTED',
      to: 'CANCELED',
      metric: 'DURATION',
      action_by: 'user',
      value: '5',
      fee_period: 'pending',
      fee_amount: '0.5',
      transaction_type_slug: 'user-cancellation',
      source: 'user',
      target: 'driver',
      localId: '0.30782144931739785',
    },
    {
      from: 'ARRIVED',
      to: 'CANCELED',
      metric: 'DURATION',
      action_by: 'driver',
      value: '0',
      fee_period: 'instant',
      fee_amount: '0.5',
      transaction_type_slug: 'user-cancellation',
      source: 'user',
      target: 'driver',
      localId: '0.875929311282539',
    },
  ],
  rules: [
    {
      from: 'ACCEPTED',
      to: 'ARRIVED',
      metric: 'DISTANCE',
      action_by: 'driver',
      value: '0.175',
      localId: '0.8466456961633237',
    },
  ],
}

export default function useTripConfigForm(props, ctx) {
  const tabIndex = ref(0)
  const configObj = reactive({
    key: `${ctx.root.$route.params.zone}::${ctx.root.$route.params.service}`,
    fines: [],
    rules: [],
    cancellation_reasons: [],
    driver_offer: null,
    display_phone_options: null,
    delay_discount: [],
    distance_bonus: [],
    bogo_config: [],
  })

  const tripConfigData = computed(
    () => ctx.root.$store.getters['tripConfig/getTripConfig'],
  )
  const transactionTypes = computed(
    () => store.getters['transactionTypes/getTransactionTypes'],
  )
  const loadingTabs = ref(false)
  const fetchTripConfig = async () => {
    try {
      loadingTabs.value = true
      await store.dispatch('transactionTypes/fetchTransactionTypes')

      if (!props.isNew) {
        if (!tripConfigData.value) {
          await ctx.root.$store.dispatch('tripConfig/fetchTripConfig', {
            zone: ctx.root.$route.params.zone,
            service: ctx.root.$route.params.service,
          })
        }

        Object.entries(tripConfigData.value).forEach(([key, value]) => {
          configObj[key] = value
        })
      }
    } catch (error) {
      Object.entries(DEFAULT_CONFIG).forEach(([key, value]) => {
        configObj[key] = value
      })
      console.log('NOT FOUND?')
      console.log(error)
    } finally {
      loadingTabs.value = false
    }
  }
  const loadingConfig = ref(false)
  const postForm = async () => {
    try {
      loadingConfig.value = true
      await ctx.root.$store.dispatch('tripConfig/postForm', configObj)
      ctx.root.$router.push('/trip-config')
    } catch (error) {
      console.log(error)
    } finally {
      loadingConfig.value = false
    }
  }

  fetchTripConfig()

  onUnmounted(() => {
    ctx.root.$store.commit('tripConfig/SET_TRIP_CONFIG_DATA', null)
  })

  return {
    configObj,
    tabIndex,
    transactionTypes,
    loadingTabs,
    fetchTripConfig,
    postForm,
    loadingConfig,
  }
}
